var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SvgInteractionsListener',{attrs:{"svg-url":_vm.svgUrl,"svg-data":_vm.svgData}})
}
var staticRenderFns = []

export { render, staticRenderFns }